import {
    FormattedRpServiceConfiguration,
    FormattedRpServiceConfigurationProperty
} from "@idw-types/data/rp-service-configuration";
import { RpServiceConfigurationPropertyContainer } from "../rp-service-configuration-property-container/rp-service-configuration-property-container";

type RpServiceConfigurationPropertiesContainerProps = {
    isDisabled: boolean;
    selectedRpServiceConfigurationProperties: Array<FormattedRpServiceConfigurationProperty>;
    rpServiceConfigurationState: FormattedRpServiceConfiguration;
    setRpServiceConfigurationState: (state: FormattedRpServiceConfiguration) => void;
};

export const RpServiceConfigurationPropertiesContainer = (props: RpServiceConfigurationPropertiesContainerProps) => {
    const { isDisabled, selectedRpServiceConfigurationProperties, rpServiceConfigurationState, setRpServiceConfigurationState } = props;

    const setRpServiceConfigurationPropertyValue = (rpServiceConfigurationProperty: FormattedRpServiceConfigurationProperty, newValue: string) => {
        const newProperties = rpServiceConfigurationState.properties.map(property => (property.propertyTypeId === rpServiceConfigurationProperty.propertyTypeId ? {
            ...property,
            value: newValue
        } : property));

        setRpServiceConfigurationState({
            ...rpServiceConfigurationState,
            properties: newProperties
        });
    };

    const removeRpServiceConfigurationProperty = (rpServiceConfigurationProperty: FormattedRpServiceConfigurationProperty) => {
        const newProperties = rpServiceConfigurationState.properties.map(property => (property.propertyTypeId === rpServiceConfigurationProperty.propertyTypeId ? {
            ...property,
            addedToService: false
        } : property));

        setRpServiceConfigurationState({
            ...rpServiceConfigurationState,
            properties: newProperties
        });
    };

    return (
        <div>
            {selectedRpServiceConfigurationProperties.map(property => (
                <RpServiceConfigurationPropertyContainer
                    key={`selected-service-property-${property.propertyTypeId}`}
                    isDisabled={isDisabled}
                    idPrefix={"service-details"}
                    rpServiceConfigurationProperty={property}
                    removeRpServiceConfigurationProperty={removeRpServiceConfigurationProperty}
                    setRpServiceConfigurationPropertyValue={setRpServiceConfigurationPropertyValue}
                />
            ))}
        </div>
    );
};